import React from "react";
import {CommonInputProps, HTMLInputElementProps, PropsWithOverwrite} from "../../../utils/input";
import clsx from "clsx";

export type InputProps<T> = PropsWithOverwrite<HTMLInputElementProps, CommonInputProps<T>>;

const Input = <T extends string | number>({value, onChange, small, cssClass, ...inputAttr}: InputProps<T>) => {
    const handleChange = (newValue: string) => {
        if (typeof value === "number") {
            onChange(Number(newValue) as T);
        } else {
            onChange(newValue as T);
        }
    };

    return (
        <input
            id={inputAttr.name}
            value={value}
            onChange={(e) => handleChange(e.target.value)}
            className={clsx(cssClass, {"input--small": small})}
            {...inputAttr}
        />
    );
};

export default Input;
